<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <div v-for="(item,index) in phaseDataList" style="margin-top: 5px;border: 1px #ccc solid;width: 1500px" >
      <!----------------期数------------------>
      <div style="width: 100%;height: 30px;margin-top: 5px;display: flex;justify-content:center;">
        <div style="display: flex; align-items: center;">
          <div style="width: 100px;text-align: right;">期数：</div>
          <el-input v-model="item.phase" style="width: 200px" disabled></el-input>
          <div style="width: 200px;text-align: right">本期金额：</div>
          <div style="width: 200px;font-size: 18px;color: red" disabled>{{formatMoney(item.phasePrice)}}</div>
          <el-button type="danger" style="margin-left: 50px" @click="delPhaseLine(item,index)" :disabled="isDisable">删除本期明细</el-button>
        </div>
      </div>
      <!-----------------------标题------------------>
      <div style="display: flex; justify-content: center">
        <div
            style="width: 100%;display: flex;line-height: 30px;background-color: #cccccc;text-align:center;margin-top: 5px">
          <div style="width: 30px;background-color: white"></div>
          <div style="width: 30px;background-color: white"></div>
          <div style="flex: 1;">产品名称</div>
          <div style="width: 150px">产品编码</div>
          <div style="width: 150px">授权方式</div>
          <div style="width: 80px">单位</div>
          <div style="width: 80px">数量</div>
          <div style="width: 120px">单价</div>
          <div style="width: 80px">税率(%)</div>
          <div style="width: 100px">税额</div>
          <div style="width: 100px">未税金额</div>
          <div style="width: 120px">进货来源</div>
          <div style="width: 120px">业务归属</div>
        </div>
      </div>
      <!------------------------产品列--------------------->
      <el-scrollbar style="height: 200px;margin-top: 5px" always>
        <div v-for="productInfo in item.productInfoList" style="width: 100%;display: flex;justify-content: center">
          <div style="width: 100%;height:35px;display: flex;line-height: 30px;margin-top: 10px;">
            <div style="width:30px;display: flex; align-items: center; justify-content: center;cursor: pointer;" @click="addLine(index)" >
              <el-icon :size="22" ><CirclePlus /></el-icon>
            </div>
            <div style="width: 30px;display: flex; align-items: center; justify-content: center;cursor: pointer;" @click="delLine(productInfo,index)">
              <el-icon :size="22"><Remove /></el-icon>
            </div>
            <div style="flex: 1; ">
              <el-cascader v-model="productInfo.productId" :options="productList" style="width: 100%"
                           :show-all-levels="false" placeholder="选择产品" :props="props" :disabled="isDisable"
                           clearable filterable @change="getProductInfoById(productInfo)"/>
            </div>
            <div style="width: 150px;text-align: center">
              {{ productInfo.code }}
            </div>
            <div style="width: 150px">
              <el-select v-model="productInfo.authorize_type" clearable :disabled="isDisable">
                <el-option v-for="item in authorizeTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </div>
            <div style="width: 80px;padding: 0 5px;text-align: center">
              {{ productInfo.unit }}
            </div>
            <div style="width: 80px;padding: 0 5px">
              <el-input-number style="width: 70px" min="0" :controls="false" :disabled="isDisable"
                               v-model="productInfo.cnt" @change="priceCalculation()">
              </el-input-number>
            </div>
            <div style="width: 120px;padding: 0 5px;">
              <el-input-number style="width: 110px" min="0" :precision="2" :controls="false" :disabled="isDisable"
                               v-model="productInfo.unit_price" @change="priceCalculation()">
              </el-input-number>
            </div>
            <div style="width: 80px;padding: 0 5px;">
              <el-input-number style="width: 70px" min="0" :controls="false" :disabled="isDisable"
                               v-model="productInfo.rate" @change="priceCalculation()">
              </el-input-number>
            </div>
            <div style="width: 100px;text-align: center">
              {{ productInfo.rate_price }}
            </div>
            <div style="width: 100px;text-align: center">
              {{ productInfo.no_rate_price }}
            </div>
            <div style="width: 120px;text-align: center">
              <el-select style="width: 110px" v-model="productInfo.supplier" clearable :disabled="isDisable">
                <el-option v-for="item in supplierList" :key="item.id" :value="item.id" :label="item.name_key"></el-option>
              </el-select>
            </div>
            <div style="width: 120px;text-align: center">
              <el-select style="width: 110px" v-model="productInfo.belong_area" clearable :disabled="isDisable">
                <el-option v-for="company in companyList" :key="company.value" :label="company.label" :value="company.value"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <div style="width: 100%;text-align: center;margin-top: 10px">
      <el-button type="success" @click="addNewPhaseLine" :disabled="isDisable">新增一期产品明细</el-button>
      <el-button type="primary" style="width: 150px;" @click="saveData" :disabled="isDisable">保存</el-button>
      <span v-if="isReview && !isDisable" style="margin-left: 10px;line-height: 32px;font-size: 12px">{{'(已保存)'}}</span>
    </div>

  </div>
</template>

<script>
import {CirclePlus, Remove} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";

export default {
  name: "CrmWinProducts",
  components: {CirclePlus, Remove},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return {
      phaseDataList:[],
      productList:[],
      supplierList:[],
      companyList:[],
      isDisable:false,
      is_review:false,
      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      isReview:false,

    }
  },
  computed: {
    authorizeTypeList() {
      return this.$store.getters['core/getDictList']('authorize_type');
    },
  },
  async created() {
    await this.getCompanyList();
    await this.initData();

  },
  methods: {
    async initData(){
      let data = this.getCrmProductInfo();
      if(data === true){
        return;
      }
      this.addTwoLine();
      this.getProductList();
      this.getSupplierList();
    },
    async getCrmProductInfo(){
      let params = {chance_id:this.parentData.id}
      let data = await this.$http('crmWinService.getWinProductInfo',params);
      if(data.winProductInfoList.length === 0){
        this.isDisable = false;
        return false;
      }else {
        this.phaseDataList = data.winProductInfoList;
        this.isReview = data.isReview;
        //成单审核状态  优先级最高
        if(this.parentData.win_review_status){
          this.isDisable = true;
          return true;
        }
        //审核窗口进来的 次之
        if (this.parentData.is_review) {
          this.isDisable = false;
          this.is_review = true;
        } else {
          this.isDisable = true;
        }
        return true;
      }
    },
    async saveData(){
      let params = {};
      let phaseList = [];
      for (let i = 0; i < this.phaseDataList.length; i++) {
        let item = this.phaseDataList[i];
        let productList = [];
        if (item.productInfoList) {
          for (let j = 0; j < item.productInfoList.length; j++) {
            let productInfo = item.productInfoList[j];
            if(!productInfo.productId && !productInfo.authorize_type){
              continue;
            }
            if(!productInfo.productId){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，产品名称为空');
            }
            if(!productInfo.authorize_type){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，授权方式为空');
            }
            if(productInfo.cnt === undefined || productInfo.cnt === ''){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，数量为空');
            }
            if(productInfo.unit_price === undefined || productInfo.unit_price === ''){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，单价为空');
            }
            if(productInfo.rate === undefined || productInfo.rate === ''){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，税率为空');
            }
            if(!productInfo.supplier){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，进货来源为空');
            }
            if(!productInfo.belong_area){
              return this.$message.error('第'+(i+1)+'期，第'+(j+1)+'行，业务归属为空');
            }
            productList.push({...productInfo})
          }
        }
        if (productList.length !== 0) {
          phaseList.push({id:item.id,phase:i+1,phasePrice:item.phasePrice,productInfoList:productList})
        }

      }

      params.phaseList = phaseList;
      params.chance_id = this.parentData.id;
      params.is_review = this.is_review;
      if(phaseList.length === 0){
        return this.$message.error('产品清单为空');
      }
      await this.$http('crmWinService.saveWinProductInfo',params);
      await this.$message.success('保存成功');
      await this.initData();

      let isReview = await this.$http('crmWinService.checkIsAllReview',params);
      if(isReview === true){
        this.$fn.search();
        this.$fn.closeWindow();
      }
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'wu',label:'无'})
      this.companyList = data;
    },
    //计算价格 ，未税价格，税额，本期金额等
    priceCalculation(){
      this.phaseDataList.forEach(item=> {
        item.phasePrice = 0;
        let productInfo = item.productInfoList;
        if (productInfo) {
          productInfo.forEach(productInfo => {
            if(productInfo.unit_price !== undefined && productInfo.cnt !== undefined){
              productInfo.total_price = parseFloat((productInfo.unit_price * productInfo.cnt).toFixed(2));
            }
            if (productInfo.total_price !== undefined && productInfo.rate !== undefined) {
              productInfo.no_rate_price = parseFloat(( productInfo.total_price / (1 + productInfo.rate / 100) ).toFixed(2));
              productInfo.rate_price = parseFloat((productInfo.total_price - productInfo.no_rate_price).toFixed(2));
              item.phasePrice = item.phasePrice + productInfo.total_price
            }
          })
        }
      })
    },
    //选择产品后 获取产品信息
    async getProductInfoById(productInfo){
      if(!productInfo.productId){
        productInfo.code = '';
        productInfo.unit = '';
        return;
      }
      let params = {product_id:productInfo.productId}
      let product = await this.$http('crmProductService.getProductById',params);
      productInfo.code = product.code;
      productInfo.unit = product.unit;
    },
    //获取产品列表
    async getProductList(){
      this.productList = await this.$http('crmDsService.getCatalogWithProducts');
    },
    //获取供应商列表
    async getSupplierList(){
      this.supplierList = await this.$http('crmDsService.getSupplierList');
    },
    addTwoLine(){
      for (let i = 0; i < 2; i++) {
        this.phaseDataList.push({
          id: nanoid(),
          phase: '第' + (i+1) + '期',
          productInfoList:[{id:nanoid()},{id:nanoid()}]
        })
      }
    },
    addNewPhaseLine(){
      this.phaseDataList.push({
        id: nanoid(),
        phase: '第' + (this.phaseDataList.length+1) + '期',
        productInfoList:[{id:nanoid()}]
      })
    },
    delPhaseLine(item,index){
      if(this.phaseDataList.length === 1){
        return;
      }
      this.phaseDataList.splice(index,1);
      this.phaseDataList.forEach((item,index)=>{
        item.phase = '第' + (index + 1) + '期'
      })
    },
    addLine(index){
      if(this.isDisable === true){
        return;
      }
      this.phaseDataList[index].productInfoList.push({
        id: nanoid(),
      })
    },
    delLine(node,index){
      if(this.isDisable === true){
        return;
      }
      if(this.phaseDataList[index].productInfoList.length === 1){
        return;
      }
      let delId = node.id
      this.phaseDataList[index].productInfoList.forEach(item => {
        if(delId === item.id){
          this.phaseDataList[index].productInfoList.splice(this.phaseDataList[index].productInfoList.indexOf(item),1)
        }
      })
    },
    //将数字转换成金额显示
    formatMoney(num) {
      if(num === undefined || num === ''){
        return '0';
      }
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },

  }


}
</script>

<style scoped>

</style>